module.exports = __webpack_public_path__ + "static/img/002.83b0655.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner/002.jpeg
// module id = fdMO
// module chunks = 11